<template>
    <HeaderAdmin />
    <div class="main_bottom_box">
        <SidebarAdmin />
        <GroupwiseSalaryPovisionAllocation />
    </div>
</template>
<script>
import { createLocal } from 'the-storages'
import { BASE_URL } from "../config";
import axios from "axios";

const mirror = createLocal()
const storage = mirror._prx


import HeaderAdmin from "../components/AdminDashboard/HeaderAdmin.vue";

import SidebarAdmin from "../components/AdminDashboard/SidebarAdmin.vue";

import GroupwiseSalaryPovisionAllocation from "../components/AdminDashboard/GroupwiseSalaryPovisionAllocation.vue";

export default {
    name: 'GroupwiseSalaryPovisionAllocationPage',
    components:{
        HeaderAdmin,
        SidebarAdmin,
        GroupwiseSalaryPovisionAllocation
    },
    data() {
        return {
            storageData: mirror,
            storage: storage,
        }
    },
    methods :{

    },
    async created(){
        this.userName = mirror.USERNAME
   },
   beforeRouteEnter(to, from, next) {
    console.log(mirror);
        if (mirror.USEREMAIL=='superadmin@admin.com') {
            next();
            console.log("next");
        }
        else {
            next('/adminDashboard');
            console.log("back");

        }
    }
}
</script>
<style scoped>
</style>